var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.products,{tag:"component",attrs:{"brand":_vm.brand,"request-for-categories":_vm.requestForCategories,"is-category-page":_vm.isCategoryPage,"filter2subcategories":_vm.filter2subcategories},on:{"resetFilters":_vm.resetFilters}})}
var staticRenderFns = []

export { render, staticRenderFns }